import { useWindowSize } from "@/utils/hooksUtils";
import CountUp from "react-countup";
import { DASHBOARD_LARGER_SCREEN_UPDATE_WIDTH } from "../../../../../utils";

type Props = {
  value: number;
};

export const StatNumber = ({ value }: Props) => {
  const windowSize = useWindowSize();

  return (
    <CountUp
      style={{
        fontSize: windowSize.innerWidth >= DASHBOARD_LARGER_SCREEN_UPDATE_WIDTH ? 28 : 24,
        lineHeight: "48px",
        fontWeight: 600,
      }}
      duration={4}
      separator={" "}
      end={value}
    />
  );
};
